import React from "react";
import Particles from "react-tsparticles";
import Particle from "./Particle";
import Welcome from "./Welcome";
import AboutMe from "./AboutMe";
import Navbar from './Navbar';
import NavBottom from "./NavBottom";
import Projects from "./Projects";
import Blog from "./Blog";
import Contact from "./Contact";


const Main = () => {
    return (
        <div className="main">   
            <Navbar />
            <Welcome />
            <AboutMe />
            <Projects />
            <Blog />
            <Contact />
            <NavBottom />
            
        </div>
    );
}

export default Main;